// export action types
import { UPDATE_MEMBER_MANAGEMENT_STATE, CLEAR_MEMBER_MANAGEMENT_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { updateMemberManagementState } from 'actions/updateMemberManagementState';
 *
 * // dispatch action
 * store.dispatch( updateMemberManagementState( payload ) );
 */
export const updateMemberManagementStateAction = ( payload ) => {
    return {
        type: UPDATE_MEMBER_MANAGEMENT_STATE,
        payload: payload
    };
};

/**
 * import { clearMemberManagementState } from 'actions/updateMemberManagementState';
 *
 * // dispatch action
 * store.dispatch( clearMemberManagementState() );
 */
export const clearMemberManagementStateAction = () => {
    return {
        type: CLEAR_MEMBER_MANAGEMENT_STATE,
        payload: null
    };
};
